export default function Page404() {
  return <div className='flex-grow-1'>Error: 404</div>;
}
